module.exports = __webpack_public_path__ + "img/pt_seguromultidispositivo.0f1be31e.png";